import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  aiLogList: [],
  aiLog: undefined,
  listLoading: false,
  actionsLoading: false,
  error: null,
  countAiLog: 0,
  currentAiLog: undefined,
  userActiveTrend: [],
  userActivityTrend: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const slice = createSlice({
  name: "customerSuccessAiLog",
  initialState: initialState,
  reducers: {
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    endCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    aiLogsFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.aiLogList = data.data;
      state.countAiLog = data.totalCount;
    },

    aiLogFetched: (state, action) => {
      state.actionsLoading = false;
      state.aiLog = action.payload.data;
      state.error = null;
    },

    aiLogDetailFetched: (state, action) => {
      state.actionLoading = false;
      state.error = null;
      state.currentAiLog = action.payload.data.data;
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

  }
}); 
